import { rootApi } from "@/services/api/api";
import type {
  CreateNoteRequest,
  CreateNoteResponse,
  GetAllNotesResponse,
  GetNoteByIdRequest,
  GetNoteByIdResponse,
  UpdateNoteRequest,
  UpdateNoteResponse,
} from "../types";

export const noteApi = rootApi.injectEndpoints({
  endpoints: (build) => ({
    getAllNotes: build.query<GetAllNotesResponse, void>({
      query: () => ({
        url: "/notes/all",
        method: "GET",
      }),
      providesTags: ["person", "note", "file"],
    }),
    deleteNoteById: build.mutation<void, string>({
      query: (id) => ({
        url: `notes/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["note", "person", "calendarEvent"],
    }),
    deleteNotesByIds: build.mutation<void, string[]>({
      query: (ids) => ({
        url: "notes/delete",
        body: ids,
        method: "DELETE",
      }),
      invalidatesTags: ["note", "person", "calendarEvent"],
    }),
    getNoteById: build.query<GetNoteByIdResponse, GetNoteByIdRequest>({
      query: ({ noteId }) => ({
        url: `notes/${noteId}`,
        method: "GET",
      }),
    }),
    updateNote: build.mutation<UpdateNoteResponse, UpdateNoteRequest>({
      query: (note) => ({
        url: "notes/update",
        body: note,
        method: "PUT",
      }),
      invalidatesTags: ["calendarEvent"],
    }),
    createNote: build.mutation<CreateNoteResponse, CreateNoteRequest>({
      query: (note) => ({
        url: "notes/create",
        body: note,
        method: "POST",
      }),
      invalidatesTags: ["note", "person", "calendarEvent"],
    }),
  }),
});

export const {
  useGetAllNotesQuery,
  useDeleteNoteByIdMutation,
  useLazyGetAllNotesQuery,
  useDeleteNotesByIdsMutation,
  useCreateNoteMutation,
  useUpdateNoteMutation,
  useLazyGetNoteByIdQuery,
} = noteApi;
